import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { useCallback, useEffect } from "react";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { defaultReportSaldoBancarioForm, ReportSaldoBancarioForm, ReportSaldoBancarioSchema } from "../../../schemas/reports/saldoBancarioReport";

type opcoes = {
    id: number;
    title: string;
}

type props = {
    open: boolean,
    saving: boolean,
    selectedIdBancoPagamento: number
    onClose: () => void,
    onSubmit: (form: ReportSaldoBancarioForm) => void,

}

export const SaldoBancarioReportModal = ({
    open,
    saving,
    selectedIdBancoPagamento,
    onClose,
    onSubmit,

}: props) => {


    const hookForm = useForm<ReportSaldoBancarioForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultReportSaldoBancarioForm,
        resolver: zodResolver(ReportSaldoBancarioSchema),
    });


    useEffect(() => {
        if (open) {
            if (selectedIdBancoPagamento) {
                hookForm.reset();
                hookForm.setValue("idBancoPagamento", selectedIdBancoPagamento);
            } else {
                hookForm.reset();
            }
        }
    }, [open, hookForm, selectedIdBancoPagamento]);

    const handleSubmit = useCallback((form: ReportSaldoBancarioForm) => {
        if (!saving) {
            onSubmit(form);
        }
    }, [saving, onSubmit]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    const tipoMovimentos: opcoes[] = [
        { id: 1, title: "Crédito em conta corrente" },
        { id: 2, title: "Débito em conta corrente" },
        { id: 3, title: "Contas Pagar" },
        { id: 4, title: "Contas Receber" },
        { id: 5, title: "Estorno de contas a pagar" },
        { id: 6, title: "Estorno de contas a receber" },
    ];

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Relatório de Saldo Bancário
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>

                            <DefaultFormMultiAutocomplete
                                name='tipoMovimento'
                                label='Tipo de Movimento'
                                options={tipoMovimentos}
                                getOptionKey={x => x.id}
                                getOptionLabel={x => x.title}
                                reactHookForm={hookForm}
                            />

                            <div className="grid grid-cols-2 gap-4 mb-3">
                                <FormDatePickerInput
                                    name="dataDe"
                                    label="Pago De"
                                    reactHookForm={hookForm}
                                />

                                <FormDatePickerInput
                                    name="dataAte"
                                    label="Pago Até"
                                    reactHookForm={hookForm}
                                />

                            </div>

                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Gerar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}